const API_BASE_URL = process.env.REACT_APP_API_URL || `${process.env.REACT_APP_API_URL}`;

export const authAPI = {
  login: (email, password) =>
    fetch(`${API_BASE_URL}/api/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password })
    }).then(async res => {
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || 'Login failed');
      return data;
    }),

  register: (data) =>
    fetch(`${API_BASE_URL}/api/auth/register`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    }).then(async res => {
      const text = await res.text();
      if (!res.ok) throw new Error(text || 'Registration failed');
      return text;
    }),

  verifyOtp: (data) =>
    fetch(`${API_BASE_URL}/api/auth/verify-otp`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    }).then(res => res.text()),

  resendOtp: (email) =>
    fetch(`${API_BASE_URL}/api/auth/resend-otp`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email })
    }).then(async res => {
      const text = await res.text();
      if (!res.ok) throw new Error(text);
      return text;
    })
};
